module.exports = __webpack_public_path__ + "static/media/icon_plus_store_disabled.cb3da644.svg";